import { useSearchParams } from 'react-router-dom'

import { useLoadUser } from '../../queries/useUserQueries'

export function useDashboardBack() {
    const [searchParams] = useSearchParams()
    const clientId = searchParams.get('clientId') ?? undefined
    const { data: client, isLoading: isLoadingClient } = useLoadUser(clientId)

    if (isLoadingClient || !client) {
        return {
            label: 'Home',
            href: '/',
        }
    }

    return {
        label: `${client.name}'s History`,
        href: `/dashboard/user/${client.id}`,
    }
}
